import api from './client';
import type { Payment } from 'types/payment';

export interface CreatePaymentData {
  ordre_id: string;
  type: 'acompte' | 'solde';
  amount: number;
  reglement_infos: {
    email: string;
    phone?: string;
    name: string;
    first_name?: string;
  };
}

export const paymentsApi = {
  create: async (data: CreatePaymentData): Promise<Payment> => {
    const { data: result } = await api.post('/payments', data);
    return result;
  },

  listForOrdre: async (ordreId: string): Promise<Payment[]> => {
    const { data } = await api.get('/payments', { params: { ordre_id: ordreId } });
    return data;
  },

  get: async (id: string): Promise<Payment> => {
    const { data } = await api.get(`/payments/${id}`);
    return data;
  },

  cancel: async (id: string): Promise<Payment> => {
    const { data } = await api.post(`/payments/${id}/cancel`);
    return data;
  },

  resend: async (id: string): Promise<Payment> => {
    const { data } = await api.post(`/payments/${id}/resend`);
    return data;
  },
};
